import Link from "next/link";
import { LucideIcon } from "lucide-react";

interface ContactIconProps {
    href: string;
    icon: LucideIcon;
    label: string;
}

export function ContactIcon({ href, icon: Icon, label }: ContactIconProps) {
    return (
        <a
            href={href}
            className="group block"
            title={label}
            aria-label={label}
        >
            <div className="bg-secondary rounded-full p-2 group-hover:bg-[#7db336] transition-colors shadow-sm flex items-center justify-center">
                <Icon className="h-4 w-4 text-white" />
            </div>
        </a>
    );
}
